import Swiper from 'swiper';
import { EffectCreative, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

export default () => {

    let swipers = document.querySelectorAll(".explore-products-swiper");
    if (!swipers.length) {
        return;
    }


    const mediaMobile = window.matchMedia("(max-width: 1023px)");

    swipers.forEach(node => {

        let swiperId = "#" + node.id;

        const options = {

            modules: [EffectCreative],
            init: false,
            speed: 600,
            loop: true,
            simulateTouch: true,
            slidesPerView: 1,
            spaceBetween: 24,
            parallax: true,
            centeredSlides: true,
            breakpoints: {
                1024: {
                    simulateTouch: false,
                    slidesPerView: 2.25,
                    spaceBetween: 0,
                }
            },
            effect: "creative",
            creativeEffect: {
                limitProgress: 2,
                prev: {
                    opacity: 0.6,
                    scale: 0.6,
                    translate: ["-85%", 0, 0],
                },
                next: {
                    opacity: 0.6,
                    scale: 0.6,
                    translate: ["85%", 0, 0],
                },
            },
            navigation: {
                nextEl: `${swiperId}-navigation .swiper-button-next`,
                prevEl: `${swiperId}-navigation .swiper-button-prev`,
            },

        }

        let swiperExploreProducts = new Swiper(swiperId, options);
        if (swiperExploreProducts) {

            swiperExploreProducts.on('init', () => {
                if (!mediaMobile.matches) {
                    swiperExploreProducts.slideNext();
                }
            });

            swiperExploreProducts.init();

        }

    });

}